(function () {
  // Mobile menu toggle
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.step, 10);
        input.value = Math.max(parseInt(input.min || '1', 10), v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product page: gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.src;
        main.srcset = '';
        main.alt = t.dataset.alt || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Product page: variant selection
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var selects = form.querySelectorAll('[data-option-index]');
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  // Product page: live personalisation preview
  document.querySelectorAll('[data-preview]').forEach(function (prev) {
    var form = document.getElementById(prev.dataset.preview);
    if (!form) return;
    var text = prev.querySelector('span');
    var fallback = text.textContent;
    var nameInput = form.querySelector('[data-preview-name]');
    var fontInputs = form.querySelectorAll('[data-preview-font]');
    function render() {
      text.textContent = (nameInput && nameInput.value.trim()) || fallback;
      fontInputs.forEach(function (f) { if (f.checked) text.style.fontFamily = f.dataset.previewFont; });
    }
    if (nameInput) nameInput.addEventListener('input', render);
    fontInputs.forEach(function (f) { f.addEventListener('change', render); });
    render();
  });
})();
